import request from '../request'

//游戏规则列表
export const GameRuleIndexRequest = p => {
    return request({
        method:'GET',
        url:'GameRule/index',
        params: p
    })
}

//添加游戏规则
export const GameRuleAddRequest = d => {
    return request({
        method:'POST',
        url:'GameRule/add',
        data: d
    })
}

//删除游戏规则
export const GameRuleDelRequest = id => {
    return request({
        method:'DELETE',
        url:'GameRule/del',
        data: {
            id: id
        }
    })
}

//修改游戏规则
export const GameRuleEditRequest = data => {
    return request({
        method:'PUT',
        url:'GameRule/edit',
        data
    })
}

//获取游戏规则详情
export const GameRuleDetailsRequest = id => {
    return request({
        method:'GET',
        url:'GameRule/details',
        params: {
            id
        }
    })
}

//游戏规则序列
export const GameRuleListRequest = () => {
    return request({
        method:'GET',
        url:'GameRule/list'
    })
}